import { Link } from 'react-router'

import Avatar from './components/Avatar'
import Wrapper from './components/Wrapper'

const UserCard = ({ entity, 'data-feed': dataFeed }) => {
    // iconUrl is an alias used in searchQuery
    const { url, name, icon, iconUrl } = entity
    return (
        <Wrapper as={Link} to={url} data-feed={dataFeed}>
            <Avatar image={icon || iconUrl} name={name} />
            {name}
        </Wrapper>
    )
}

export default UserCard
